import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ed7f513"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "second-pdf-page" }
const _hoisted_2 = { class: "second-pdf-page__content" }
const _hoisted_3 = {
  key: 0,
  class: "second-pdf-page__comment"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "second-pdf-page__comment-title" }, "Комментарий врача", -1))
const _hoisted_5 = { class: "second-pdf-page__comment-text" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("ФИО врача:")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Должность:")
const _hoisted_8 = { class: "second-pdf-page__footer" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "second-pdf-page__footer-title" }, " Digitalized by DIANA™ — Dental Index Analysis Application "),
  /*#__PURE__*/_createElementVNode("p", { class: "second-pdf-page__footer-text" }, " Результаты расчета не являются диагнозом или медицинской рекомендацией и не заменяют консультации с врачом. ")
], -1))
const _hoisted_10 = ["innerHTML"]

import { computed } from 'vue'
import {
  ConsolidatedDataType,
  ConsolidatedTableType,
  PeriodontalReportType,
  CommentType,
} from '@/shared/types'
import { WConsolidatedReport } from '@/widgets/WConsolidatedReport'
import { EPeriodontalGraphic } from '@/entities/EPeriodontalGraphic'
import { EPeriodontalMapTable } from '@/entities/EPeriodontalMapTable'
import { LOGO } from '@/shared/constants'

interface Props {
  data: PeriodontalReportType
  previousData: PeriodontalReportType
  plaque: number
  reCleaning: number
  bleeding: number
  pockets: number
  pocketsTable: ConsolidatedTableType[]
  comments: CommentType[]
  consolidatedData: ConsolidatedDataType
}


export default /*#__PURE__*/_defineComponent({
  props: {
    data: null,
    previousData: null,
    plaque: null,
    reCleaning: null,
    bleeding: null,
    pockets: null,
    pocketsTable: null,
    comments: null,
    consolidatedData: null
  },
  setup(__props: any) {

const props = __props as {
  data: PeriodontalReportType
  previousData: PeriodontalReportType
  plaque: number
  reCleaning: number
  bleeding: number
  pockets: number
  pocketsTable: ConsolidatedTableType[]
  comments: CommentType[]
  consolidatedData: ConsolidatedDataType
}



const lastComment = computed(
  (): CommentType => props.comments[props.comments.length - 1]
)

return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(EPeriodontalMapTable), {
        class: "second-pdf-page__table",
        columns: __props.data.secondTongueData.getData(),
        "is-pdf-mode": ""
      }, null, 8, ["columns"]),
      _createVNode(_unref(EPeriodontalGraphic), {
        class: "second-pdf-page__chart",
        "facial-side-data": __props.data.secondFacialDiagram,
        "tongue-side-data": __props.data.secondTongueDiagram,
        "facial-side-previous-data": __props.previousData?.secondFacialDiagram,
        "tongue-side-previous-data": __props.previousData?.secondTongueDiagram,
        "is-upper-teeth": false,
        "is-pdf-mode": "",
        "is-reverse": ""
      }, null, 8, ["facial-side-data", "tongue-side-data", "facial-side-previous-data", "tongue-side-previous-data"]),
      _createVNode(_unref(EPeriodontalMapTable), {
        columns: __props.data.secondFacialData.getData(),
        "is-reverse": "",
        "is-pdf-mode": ""
      }, null, 8, ["columns"])
    ]),
    _createVNode(_unref(WConsolidatedReport), {
      class: "second-pdf-page__item",
      "is-pdf-mode": "",
      plaque: __props.plaque,
      bleeding: __props.bleeding,
      pockets: __props.pockets,
      "re-cleaning": __props.reCleaning,
      "pockets-table": __props.pocketsTable,
      "consolidated-data": __props.consolidatedData
    }, null, 8, ["plaque", "bleeding", "pockets", "re-cleaning", "pockets-table", "consolidated-data"]),
    (_unref(lastComment)?.text)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_el_divider),
          _hoisted_4,
          _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(lastComment)?.text), 1),
          _createVNode(_component_el_row, { class: "second-pdf-page__comment-doctor" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 3,
                class: "text-bold"
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 21 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(lastComment)?.user_name), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { class: "second-pdf-page__comment-doctor" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 3,
                class: "text-bold"
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 21 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(lastComment)?.user_position), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", { innerHTML: _unref(LOGO) }, null, 8, _hoisted_10)
    ])
  ]))
}
}

})